import { render } from "./AppSidebarButton.vue?vue&type=template&id=9020756e&scoped=true"
import script from "./AppSidebarButton.vue?vue&type=script&lang=js"
export * from "./AppSidebarButton.vue?vue&type=script&lang=js"

import "./AppSidebarButton.vue?vue&type=style&index=0&id=9020756e&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9020756e"]])

export default __exports__